<div class="popup-mensaje-container">
  <!-- Header azul con título y botón cerrar -->
  <div class="popup-header">
    <span class="popup-titulo">{{ titulo }}</span>
    <mat-icon class="popup-close-icon" (click)="onClose()">close</mat-icon>
  </div>

  <!-- Cuerpo con ícono y texto -->
  <div class="popup-body">
    <mat-icon 
      *ngIf="icono" 
      class="popup-icono"
      [style.color]="colorIcono">
      {{ icono }}
    </mat-icon>
    <div class="popup-texto" [innerHTML]="texto"></div>
  </div>

  <!-- Footer con un solo botón -->
  <div class="popup-footer">
    <button 
      type="button"
      class="btn-action btn-mensaje"
      (click)="onAceptar()">
      {{ textoBoton }}
    </button>
  </div>
</div>
